import { render, staticRenderFns } from "./access-list-page.vue?vue&type=template&id=46ce8f30&"
import script from "./access-list-page.vue?vue&type=script&lang=ts&"
export * from "./access-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports